import { Uuid } from "./uuid";
import { NaiveDateTime } from "./datetime";
import { Taggable } from "./taggable";


export default class User extends Taggable {
    id: Uuid;
    created: NaiveDateTime;
    updated: NaiveDateTime;
    email: string;
    is_admin: boolean;
    name_prefix: string;
    name_given: string;
    name_family: string;
    name_credentials: string;
    affiliation: string;
    pass?: string;
    admin_roles: string[] | null;
    lockout_until: NaiveDateTime | null;
    stripe_customer_id: string | null;

    static fromJson(data: Object): User {
        let obj = new User();
        Object.assign(obj, data);
        return obj;
    }
};

